import { render, staticRenderFns } from "./FoodQueue.vue?vue&type=template&id=57558704&scoped=true&lang=pug&"
import script from "./FoodQueue.vue?vue&type=script&lang=ts&"
export * from "./FoodQueue.vue?vue&type=script&lang=ts&"
import style0 from "./FoodQueue.vue?vue&type=style&index=0&id=57558704&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57558704",
  null
  
)

export default component.exports